import { useCallback, useMemo } from 'react';

import {
  CopilotChatSummary,
  useDeleteChatMutation,
  useListChatsQuery,
  useRenameChatMutation,
} from '@/state/slices/copilot/copilotChats.ts';

export interface UseChatList {
  chats: CopilotChatSummary[];
  isLoading: boolean;
  rename: (uuid: string, title: string) => void;
  remove: (uuid: string) => void;
}

export function useChatList(): UseChatList {
  const { data, isLoading } = useListChatsQuery();
  const [renameChat] = useRenameChatMutation();
  const [deleteChat] = useDeleteChatMutation();

  const chats = useMemo<CopilotChatSummary[]>(
    () => data?.conversations ?? [],
    [data]
  );

  const rename = useCallback(
    (uuid: string, title: string) => {
      renameChat({ uuid, title });
    },
    [renameChat]
  );

  const remove = useCallback(
    (uuid: string) => {
      deleteChat(uuid);
    },
    [deleteChat]
  );

  return { chats, isLoading, rename, remove };
}
